import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent, TagIconComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-modal-cancel-design',
	imports: [TranslatePipe, ModalComponent, TagIconComponent],
	templateUrl: './modal-cancel-design.component.html',
	styleUrl: './modal-cancel-design.component.scss',
})
export class ModalCancelDesignComponent {
	@Input() isVisible: boolean = false;
	@Output() closeEvent = new EventEmitter<boolean | null>();

	private readonly actionMap: Record<string, boolean | null> = {
		buttonPrimary: true,
		buttonSecondary: false,
	};

	public closeModal(action: string): void {
		this.closeEvent.emit(this.actionMap[action] ?? null);
	}
}
